import React from "react";
import { Button, Box, Typography, Card, CardMedia, CardContent, CardActions, Chip } from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneIcon from '@material-ui/icons/Phone';
import Rating from '@material-ui/lab/Rating';

import useStyles from "./style";

const PlaceDetails = ({place, selected, refProp}) => {

  const classes = useStyles();

  if (selected) refProp?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

  return (
    <Card elevation={6} className={classes.root} >
      <CardMedia 
        style={{height: 350}}
        image={place.photo ? place.photo.images.large.url : 'https://tse4.mm.bing.net/th?id=OIP.fTqZC7D0d0STFEQ-Y-mYigHaE8&pid=Api&P=0&w=274&h=184'}
        title={place.name}
      />
      <CardContent>
        <Typography gutterBottom variant='h5'>{place.name}</Typography>
        <Box display='flex' justifyContent='space-between'>
          <Rating size='small' value={Number(place.rating)} readOnly />
          <Typography gutterBottom variant='subtitle1'>Out of {place.num_reviews} reviews</Typography>
        </Box>
        <Box display='flex' justifyContent='space-between'>
          <Typography variant='subtitle1'>Price</Typography>
          <Typography gutterBottom variant='subtitle1'>{place.pirce_level}</Typography>
        </Box>
        <Box display='flex' justifyContent='space-between'>
          <Typography variant='subtitle1'>Ranking</Typography>
          <Typography gutterBottom variant='subtitle1'>{place.ranking}</Typography>
        </Box> 
        { place?.awards?.map(award => (
          <Box my='2' display='flex' justifyContent='space-between' alignItems='center'>
            <img src={award.images.small} alt={award.display_name} />
            <Typography variant='subtitle2'>{award.display_name}</Typography>            
          </Box>
        )) }
        { place?.cuisine?.map(({ name }) => {
          <Chip key={name} size='small' label={name} className={classes.foodChip} />
        })}
        { place?.address && (
          <Typography gutterBottom variant='subtitle2' color='textSecondary' className={classes.subtitle} >
            <LocationOnIcon /> { place.address }
          </Typography>
        )}
        { place?.phone && (
          <Typography gutterBottom variant='subtitle2' color='textSecondary' className={classes.subtitle} >
            <PhoneIcon /> { place.phone }
          </Typography>
        )}
      </CardContent>
      <CardActions>
        <Button color='primary' size='small' onClick={() => window.open(place.web_url, '_blank')} >
          Trip Advisor
        </Button>
        <Button color='primary' size='small' onClick={() => window.open(place.website, '_blank')} >
          Website
        </Button>
      </CardActions>
    </Card>
  )
}

export default PlaceDetails;